import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import {redirecturl} from '../../../services/common/redirect';
import {RecordlogEvents} from '../../../analytics/RecordEvents'
import { useSelector } from "react-redux";
import {GTM_Select_Item} from "../../../../src/analytics/GoogleTagManager";
const SquarecardComponent = ({ data,type }) => {

    const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
    const userdata = useSelector((state) => state?.userdata?.value?.rnuserdetails);

      const {t} = useTranslation();
      const navigate = useNavigate();
      const Type =type;
      const handleRedirect = (e, url) => { 
        // try{
        //     GTM_Select_Item(data, "GTL");
        // }catch{}
        if (url?.indexOf("http") >= 0){
         window.open(url, '_blank');
         return false;
        }
        else{
        e.preventDefault();
        redirecturl(url, navigate);
        }
      }

      const handleGTLRedirect = (e, url,title) => {
        try{
            GTM_Select_Item(data, "GTL");
        }catch{}
        e.preventDefault();
        try{
            RecordlogEvents('GTL', {
                'Product Viewed': title,
                'Mobile Number': userdata?.msisdn,
                'Status': 'Success',
                'Status Description': 'Success',
                'Login Type':logintype,
                'Channel': 'WEBPORTAL',
            });
        }catch{}

        if (url?.indexOf("http") >= 0){
         window.open(url, '_blank');
         return false;
        }
        else{
        //e.preventDefault();
        redirecturl(url, navigate);
        }
      }

   


    if(Type == 1){
       return(
        <Link className="card_style_1 card_style_2img height_100" 
        //  to ={`/${data?.buyurl}`} 
        onClick={(e) => handleGTLRedirect(e, data?.buyurl,data?.title)}>
                            
        <div className="card_img">
        <img src={data?.imageurl !== undefined ? data?.imageurl : data?.imagepath !== undefined ? data?.imagepath: process.env.PUBLIC_URL + '/assets/images/dummy_img.jpg'} alt="" title="" />
            
        </div>
        <div className="card_info text-center">
            <div className="card_info_grp">
                <h4 className="text-ellipsis">{data?.title}</h4>
                <p>{data?.description}</p>
            </div>
            <div className="card_link">
                <Link 
                 className="hyperlink"
                 //onClick={(e) => handleRedirect(e, data?.buyurl)}
                 >
                    {t('kd')} {data?.amount}
                    <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} 
                    alt="" title="" />
                </Link>
            </div>
        </div>
    </Link>
       )
    }else{
   return( 
    <Link className="card_style_1 height_100"  
        // to ={`/${data?.buyurl}`} 
        onClick={(e) => handleRedirect(e, data?.buyurl)}
    >
                            
   <div className="card_img">
   <img src={data?.imageurl !== undefined ? data?.imageurl : data?.imagepath !== undefined ? data?.imagepath: process.env.PUBLIC_URL + '/assets/images/dummy_img.jpg'} alt="" title="" />
       
   </div>
   <div className="card_info text-center">
        {
            data?.tag_bgcolor && data?.tag_text && (
                <div className="card_offer" style={{backgroundColor: data?.tag_bgcolor}}>
                    <h4>{data?.tag_text}</h4>
                </div>
            )
        }
       <div className="card_info_grp">
           <h4 className="text-ellipsis">{data.title}</h4>
           <p>{data.description}</p>
       </div>
       <div className="card_link">
           <Link 
           // to ={`/${data?.buyurl}`}
            className="hyperlink"
            onClick={(e) => handleRedirect(e, data?.buyurl)}>
               {data?.action_button_text}
               <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} 
               alt="" title="" />
           </Link>
       </div>
   </div>
</Link>)
    }

  
}
export default SquarecardComponent;